import ProjectElementTypes from '@/constants/project-structure/project-element-types'
import BaseProjectRootElement from '@/classes/ProjectStructure/BaseProjectRootElement'

export default class SingleTowerProject extends BaseProjectRootElement {
  get _validChildElementTypes() {
    return [ProjectElementTypes.TOWER, ProjectElementTypes.POINT_OF_INTEREST]
  }
}
